// Pure state machine for the Poll-now button on /incidents.
//
// Extracted from incidents.tsx so it's unit-testable without dragging the
// whole route's import chain (api-client → portal-config → `document`) into
// the test environment. The component imports back from here.
//
// The UI rate-limit window mirrors POLL_NOW_RATE_LIMIT_SECS in
// packages/api/src/handlers/api-incidents-poll-now.ts. If you bump one,
// bump both — the UI window is purely a UX nicety; the API is the source
// of truth for what's actually allowed.

export const POLL_NOW_WINDOW_MS = 30_000;

export interface PollNowButtonState {
  label: string;
  disabled: boolean;
}

export function pollNowButtonState(
  now: number,
  lastSuccessfulPollAt: number | null,
  rateLimitedUntil: number | null,
  inFlight: boolean,
): PollNowButtonState {
  if (inFlight) {
    return { label: 'Polling…', disabled: true };
  }
  if (rateLimitedUntil !== null && now < rateLimitedUntil) {
    const sec = Math.max(1, Math.ceil((rateLimitedUntil - now) / 1000));
    return { label: `Try again in ${sec}s`, disabled: true };
  }
  if (lastSuccessfulPollAt !== null && now - lastSuccessfulPollAt < POLL_NOW_WINDOW_MS) {
    const elapsedSec = Math.max(0, Math.floor((now - lastSuccessfulPollAt) / 1000));
    return { label: `Polled ${elapsedSec}s ago`, disabled: true };
  }
  return { label: 'Poll now', disabled: false };
}
